module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#next-story",
      toString: function () {
        return this.url;
      }
    }